import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import {
  rabbyWallet,
  metaMaskWallet,
  coreWallet,
  rainbowWallet,
  walletConnectWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { configureChains, createConfig } from 'wagmi';
import { avalanche } from 'wagmi/chains';
import { publicProvider } from 'wagmi/providers/public';

const projectId = 'd69d155cf2bb986a4b138f4ab0c34a96';

const { chains, publicClient } = configureChains(
  [avalanche],
  [publicProvider()]
);

const connectors = connectorsForWallets([
  {
    groupName: 'Recommended',
    wallets: [
      rabbyWallet({ chains, projectId }),
      metaMaskWallet({ chains, projectId }),
      coreWallet({ chains, projectId }),
      rainbowWallet({ chains, projectId }),
      walletConnectWallet({ chains, projectId })
    ]
  }
]);

export const config = createConfig({
  autoConnect: true,
  connectors,
  publicClient
});

export { chains }; 